export var BOOKMARK_BUTTON_TRANSLATION_KEY = 'bookmark-button-course';